import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { ActivatedRoute, Router } from '@angular/router';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import moment from 'moment';
import { Clipboard } from '@angular/cdk/clipboard';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-poll',
  templateUrl: './poll.component.html',
  styleUrls: ['./poll.component.scss'],
})
export class PollComponent implements OnInit, OnDestroy {
  private destroy$ = new BehaviorSubject<void>(null);
  @ViewChild('pollDetailModal', { static: true })
  pollDetailModal: TemplateRef<any>;

  constructor(
    private router: Router,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private clipboard: Clipboard,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private title: Title
  ) {
    this.title.setTitle(`Poll | KACHIING`);
  }

  private modalRef: any;
  isLogin: any = 0;
  isLoading: boolean = false;
  appUserId: any;
  categories: any = [];
  darkModeKey: string = 'darkMode';
  // Editor = ClassicEditor;
  EditorData: any = ``;
  EditorConfig = {
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        '|',
        'bulletedList',
        'numberedList',
        '|',
        // 'insertTable',
        // 'imageUpload',
        // '|',
        'undo',
        'redo',
      ],
    },
  };
  poll: any = {
    name: '',
    startDate: '',
    endDate: '',
    polls: [],
  };
  pollDetail: any = {};
  polls: any = {
    isLoading: false,
    data: [],
    currentPage: 1,
  };
  //#9B58B5
  pollsColor: any = [
    'rgba(var(--secondary-r), var(--secondary-g), var(--secondary-b), 0.75)',
    '#3597DA',
    '#E67F22',
  ];
  newPolling: any = {};
  activeIndexPoll: number = 1;
  showFloatingMenu: boolean = false;

  ngOnInit() {
    const getUser = this.local.getUser();

    if (getUser) {
      this.appUserId = getUser.id;
    }

    getUser ? (this.isLogin = 1) : 0;
    this.isLoading = true;
    this.polls.isLoading = true;
    this.initPoll();
    setTimeout(() => {
    }, 10000);
  }

  ngOnDestroy(): void {
    // Clear all intervals
    this.polls?.data.forEach((row: any) => clearInterval(row.interval));
    this.destroy$.next();
    this.destroy$.complete();
  }

  isAdmin = () => this.local.getUser()?.role == 'admin';
  isModerator = () =>
    this.local.getUser()?.role == 'moderator' || this.isAdmin();
  isOwnMessage = (data: any) => {
    const user = this.local.getUser();
    if (!user) return false;

    if (this.isAdmin()) {
      return user.id == data.createdBy && data.isAdmin;
    } else {
      return user.id == data.createdBy && !data.isAdmin;
    }
  };

  startCountdown(item: any): void {
    item.interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = new Date(item.endDate).getTime() - now;

      if (distance < 0) {
        clearInterval(item.interval);
        item.remainingTime = "Time's up!";
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      item.remainingTime =
        (days > 0 ? days + 'd ' : '') +
        (hours < 10 ? '0' + hours : hours) +
        ':' +
        (minutes < 10 ? '0' + minutes : minutes) +
        ':' +
        (seconds < 10 ? '0' + seconds : seconds);
    }, 1000);
  }

  handlePagination(value: number) {
    const length = this.polls?.data.length - 1;
    let index = length + value;
    index = index < 0 ? length - 1 : index;
    index = index > length - 1 ? index - 1 : index;
    this.activeIndexPoll = index + 1;

    this.polls?.data.map((row: any, i: number) => {
      row.isActive = false;
      if (i == index) row.isActive = true;
    });
  }
  scrollTo(id: string) {
    this.local.scrollTo(id);
  }

  formatDate(value: any) {
    return moment.unix(value).format('YYYY-MM-DD HH:mm:ss');
  }

  newPollingStore() {
    if (this.newPolling.option == '') {
      return this.toastr.error('please fill the option name');
    }

    this.newPolling.hasSubmit = true;
    this.auth.poll_option_store(this.newPolling).subscribe(() => {
      this.newPolling.hasSubmit = false;
      this.initPoll();
      this.modalService.dismissAll();
    });
  }

  async handleShowOptionPoll(index: number) {
    await Promise.all(
      this.polls?.data.map((row: any, i: number) => {
        if (index != i) row.showOption = false;
        // row.isEdit = false
      })
    ).then(() => {
      this.polls.data[index].showOption = !this.polls.data[index].showOption;
    });
  }

  initPoll() {
    this.polls.isLoading = true;
    this.auth.poll_fetch().subscribe((response: any) => {
      this.polls = response.body;
      this.polls.data.map((row: any, i: number) => {
        if (i == 0) row.isActive = true;
      });
      this.initPollProgress();
      this.initPollLikes();
      this.showDetail('poll');
    });
  }

  openPollModal(modal: any) {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      // backdrop: 'static',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'my-modal md',
    });
    this.poll = {
      isLoading: false,
      name: '',
      startDate: '',
      endDate: '',
      polls: [],
    };
  }

  addPollsChild() {
    this.poll.polls = [...this.poll.polls, {}];
  }

  removePollsChild(i: number) {
    this.poll.polls = this.poll.polls.filter(
      (row: any, index: number) => index != i
    );
  }

  storePoll() {
    const poll = this.poll;

    // Validation

    if (
      poll.name == '' ||
      poll.startDate == '' ||
      poll.endDate == '' ||
      poll.polls.length < 1
    ) {
      return this.toastr.error('Please fill the inputs !');
    }

    const startDate = moment(poll.startDate, 'YYYY-MM-DD');
    const endDate = moment(poll.endDate, 'YYYY-MM-DD');

    if (!endDate.isAfter(startDate)) {
      return this.toastr.error('Start Date should be Greater then End date!');
    }

    // Validation

    this.poll.uuid = this.local.generateUUID();

    this.polls.hasSubmit = true;
    this.auth.poll_store(poll).subscribe(
      (response: any) => {
        this.initPoll();
        this.modalService.dismissAll();
        this.toastr.success('successfully added poll');
        this.polls.hasSubmit = false;
      },
      (e) => {
        this.polls.hasSubmit = false;
        this.toastr.error('failed to add poll');
      }
    );
  }

  checkPoll(data: any, child: any, check = false) {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    const payload = {
      userId: this.appUserId,
      pollDetailId: child.id,
      isAdmin: this.isAdmin(),
    };

    if (this.hasCheckedPoll(child.poll_interactions)) {
      data.poll_interactions_count -= 1;
      child.poll_interactions = child.poll_interactions.filter(
        (row: any) =>
          row.userId != this.appUserId && row.isAdmin != this.isAdmin()
      );
    } else {
      data.poll_interactions_count += 1;
      child.poll_interactions = [...child.poll_interactions, payload];
    }

    this.pollProgress(data, child);
    this.initPollProgress(data.id, child.id);
    this.auth.poll_check(payload).subscribe();
  }

  initPollProgress(dataId: any = null, exceptId: any = null) {
    this.polls.data.map((row: any) => {
      this.startCountdown(row);
      row.poll_interactions_count = 0;
      row.poll_details.map((item: any) => {
        item.progress = 0;
        if (exceptId != null && dataId != null) {
          if (item.id != exceptId && dataId == row.id) {
            item.poll_interactions = item.poll_interactions.filter(
              (row: any) =>
                row.userId != this.appUserId && row.isAdmin != this.isAdmin()
            );
          }
        }
        row.poll_interactions_count += item.poll_interactions.length;
      });
      row.poll_details.map((item: any) => {
        this.pollProgress(row, item);
      });
      row.poll_details.sort(
        (a: any, b: any) =>
          b.poll_interactions.length - a.poll_interactions.length
      );
    });
  }

  pollProgress(data: any, child: any) {
    const result =
      (child.poll_interactions.length / data.poll_interactions_count) * 100;
    child.progress = (result ? result : 0) + '%';
  }

  hasCheckedPoll(data: any) {
    return (
      data.filter(
        (row: any) =>
          row.userId == this.appUserId && row.isAdmin == this.isAdmin()
      ).length > 0
    );
  }

  likePoll(pollId: number, data: any) {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    const payload = {
      userId: this.appUserId,
      pollId: pollId,
      isAdmin: this.isAdmin(),
    };

    if (this.hasCheckedPoll(data.poll_likes))
      data.poll_likes = data.poll_likes.filter(
        (row: any) =>
          row.userId != this.appUserId && row.isAdmin != this.isAdmin()
      );
    else data.poll_likes = [...data.poll_likes, payload];

    this.initPollLikes();
    this.auth.poll_likes(payload).subscribe();
  }

  openNewOptionModal(event: any, modal: any, item: any) {
    event.preventDefault();
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      // backdrop: 'static',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'new_polling_option_modal',
    });
    this.newPolling = {
      title: item.name,
      id: item.id,
      option: '',
    };
  }

  initPollLikes() {
    this.polls.data.sort(
      (a: any, b: any) => b.poll_likes.length - a.poll_likes.length
    );
  }

  deletePoll(e: any, id: any) {
    e.preventDefault();
    const getConfirm = confirm('are you sure ?');

    if (getConfirm)
      this.auth.poll_delete(id).subscribe((response: any) => {
        this.toastr.error('Poll has been deleted');
        this.initPoll();
      });
  }
  showDetail(check: string) {
    this.route.queryParams.subscribe((params) => {
      const type = params.type;
      const uuid = params.uuid;
      if (type == 'poll' && check == type) {
        const data = this.polls.data.filter((row: any) => row.uuid == uuid);

        if (data.length > 0) {
          this.modalRef = this.modalService.open(this.pollDetailModal, {
            size: 'xs',
            // backdrop: 'static',
          });
          this.pollDetail = data[0];
        }
      }
    });
  }

  copyLink(type: string, item: any) {

    let currentUrl = window.location.href.split('#')[0];
    currentUrl = currentUrl + '#/forum';
    this.clipboard.copy(`${currentUrl}?type=${type}&uuid=${item.uuid}`);
    this.toastr.success(`${type.toLocaleUpperCase()} Link Copied`);
  }
}
